// use localStorage to keep value instead of cookie
export const getCookie = (name) => {
    //const cookies = new Cookies();
    //return cookies.get('token');
    var value = localStorage.getItem(name);
    var jsonParse = JSON.parse(value);
    return jsonParse;
}

export const setCookie = (name,value) => {
    //const cookies = new Cookies();
    //cookies.set("token",language,{path: '/'});
    var json = JSON.stringify(value);
    localStorage.setItem(name,json);
}

export const removeCookie = (name) => {
    localStorage.removeItem(name);
}

export const getParam = (name) => {
    var config = getCookie('config');
    if(config && Object.hasOwn(config,name)){
        return config[name];
    }
    else{
        return null;
    }
}

export const setParam = (name,value) => {
    
    var config = getCookie('config');

    if(config){
        config[name] = value;
    }
    else{
        config = {};
        config[name] = value;
    }

    setCookie('config',config);

    return config;
}

export const removeParam = (name) => {
    
    var config = getCookie('config');
    
    if(config){
        config[name] = null;
        setCookie('config',config);
    }
    
    return config;
}